import React from "react";
import {Row, Col} from "react-bootstrap";
import {RBSModal} from "../../base/rbs_components/RBSModal.tsx";
import {RBSTextField} from "../../base/rbs_components/RBSTextField.tsx";
import type {InputStateControl} from "../../base/utils/InputStateControl.tsx";
import {TextfieldInputTypes, type UserLanguages} from "../../base/Settings.tsx";
import type {TimeSeriesRowInput} from "../../base/ui_general/GeneralInterfaces.tsx";
import {ValidationSchemes, LabelTextMessageTypes} from "../../base/Settings.tsx";
import {getLabelTextMessage} from "../../base/utils/GeneralUtilities.tsx";

//TODO: There are places where the multi-language support is missing


interface TimeSeriesRowDetailModalProps {
    /** Whether the modal is visible */
    show: boolean;
    /** The time series row object to edit (if any) */
    timeSeriesRow?: TimeSeriesRowInput;
    /** Callback for submitting the form, receives a TimeSeriesRowInput object */
    onSubmit: (rowInput: TimeSeriesRowInput) => void;
    /** Callback for closing the modal */
    onClose: () => void;
    /** Indicates if the form is valid */
    isValid: boolean;
    /** Manages input state and validation */
    inputStateControl: InputStateControl;
    /** The current user language for multi-language support */
    user_language: UserLanguages;
    /** The ID of the current time series to which the row belongs */
    currentTimeSeriesId: string;
}

export const TimeSeriesRowDetailModal: React.FC<TimeSeriesRowDetailModalProps> = (props) => {
    const {timeSeriesRow, inputStateControl, user_language, currentTimeSeriesId} = props;

    const prefill = (key: keyof TimeSeriesRowInput): string => {
        if (timeSeriesRow && timeSeriesRow[key] !== undefined && timeSeriesRow[key] !== null) {
            return String(timeSeriesRow[key]);
        }
        return "";
    };

    const headerTitle = timeSeriesRow ? "Update Time Series Row" : "Create New Time Series Row";

    return (
        <RBSModal
            show={props.show}
            header_title={headerTitle}
            show_close_button
            onClose={props.onClose}
            primary_button_label={getLabelTextMessage(LabelTextMessageTypes.SUBMIT, user_language)}
            secondary_button_label={getLabelTextMessage(LabelTextMessageTypes.CANCEL, user_language)}
            onClickSecondary={props.onClose}
            primary_button_disabled={!props.isValid}
            size="sm"
            onClickPrimary={() => {
                const input: TimeSeriesRowInput = {
                    time_series_id: currentTimeSeriesId,
                    ref_date: inputStateControl.getStringValueForKey("ref_date") || "",
                    value: Number(inputStateControl.getStringValueForKey("value") || 0),
                };
                props.onSubmit(input);
                props.onClose();
            }}
        >
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label="Reference Date"
                        input_key="ref_date"
                        prefill={prefill("ref_date")}
                        validation_schemes={[ValidationSchemes.REQUIRED, ValidationSchemes.DATE]}
                        input_state_control={inputStateControl}
                        type={TextfieldInputTypes.DATE}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label="Value"
                        input_key="value"
                        prefill={prefill("value")}
                        validation_schemes={[ValidationSchemes.REQUIRED, ValidationSchemes.NUMBER]}
                        input_state_control={inputStateControl}
                        type={TextfieldInputTypes.NUMBER}
                    />
                </Col>
            </Row>
        </RBSModal>
    );
};
